// A list of dropdown values of 'Placeholder' content type's 'Type' field
export default {
  MAGENTO_COLLECTION_PRODUCTS: 'Magento: Collection page products',
  MAGENTO_UPSELL_PRODUCTS: 'Magento: Upsell products [PDP only]'
};
